export const commonMessages = {
  api: {
    genericError: "Something went wrong. Please try again.",
  },
  brand: {
    name: "NetShield",
    adminPortal: "Admin",
    adminPortalFull: "NetShield Admin Portal",
  },
} as const;
